import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type CardPinFragment = (
  { __typename: 'Card' }
  & Pick<Types.Card, 'id' | 'idBoard' | 'idList' | 'pinned'>
);

export const CardPinFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CardPin' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Card' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idBoard' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinned' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseCardPinFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<CardPinFragment, Apollo.OperationVariables>,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseCardPinFragmentResult
  extends Omit<Apollo.UseFragmentResult<CardPinFragment>, 'data'> {
  data?: CardPinFragment;
}

export const useCardPinFragment = ({
  from,
  returnPartialData,
  ...options
}: UseCardPinFragmentOptions): UseCardPinFragmentResult => {
  const result = Apollo.useFragment<CardPinFragment>({
    ...options,
    fragment: CardPinFragmentDoc,
    fragmentName: 'CardPin',
    from: {
      __typename: 'Card',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as CardPinFragment };
};
